import React, { useState, useEffect } from 'react';
import { Redirect, Route } from 'react-router-dom';
import Loading from '../components/Loading';
import axios from 'axios';
import Cookies from 'universal-cookie';
import config from '../config';

function PrivateRoute({ component: ChildComponent, location, ...rest }) {

  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const cookies = new Cookies();
    const token = cookies.get(config.accessTokenCookieKey);
    if (token) {
      axios.post('/api/validateToken', { [config.accessTokenCookieKey]: token }, {
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      })
        .then((res) => {
          // console.log('/validateToken res=', res);
          setIsAuthenticated(true);
        })
        .catch((err) => {
          console.error('err=', err);
          setIsAuthenticated(false);
        })
        .then(() => {
          setIsLoading(false);
        })
    } else {
      setIsAuthenticated(false);
      setIsLoading(false);
    }
  }, []);

  if (isLoading) {
    return (
      <Loading />
    )
  }
  if (isAuthenticated) {
    return (
      <Route
        {...rest}
        render={(props) => {
          return <ChildComponent {...props} {...rest} />
        }}
      />
    )
  } else {
    return (
      <Redirect
        {...rest}
        to={{
          pathname: "/login",
          state: { from: location }
        }}
      />
    )
  }

}

export default PrivateRoute;